<template>
  <router-view v-if="!isLoading" v-bind="$attrs" :organizations="organizationsAdmin" :organization-id="props.organizationId" @error="$emit('error', $event)" @update:organization-id="updateOrganizationId" />
</template>

<script setup>
import { onMounted, computed } from "vue";
const props = defineProps(["isLoading", "organizations", "organizationId"]);
const emit = defineEmits(["error", "update:organizationId"]);

// Computed property for filtering organizations
const organizationsAdmin = computed(() => {
  return props.organizations.filter(org => org.user_type == 1);
});

const updateOrganizationId = newOrganizationId => {
  emit("update:organizationId", newOrganizationId);
};

onMounted(() => {
  // needed if currently selected organization is not in the admin list
  if (!organizationsAdmin.value.find(org => org.id == props.organizationId) && organizationsAdmin.value.length > 0) updateOrganizationId(organizationsAdmin.value[0].id);
});
</script>
